/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef, useMemo } from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  CurrencyInput,
  DataGrid,
  Button,
  FormControl,
  DocumentoProdutoAplicacaoDialog,
  IconButton,
  Tooltip,
  TextFielDecimalNumbers,
  ProdutoEstoqueInformacaoDialog,
  OrdemCompraDialog,
  Typography,
  ListBoxAutocomplete,
  Avatar,
} from "../../../../components";
import {
  OrigemMercadoriaService,
  ProdutosService,
  SessionService,
  UnidadeComercialService,
  notification,
} from "../../../../services";
import { ProdutoSimilarDialog } from "../components";
import { PermisoesHelper, value } from "../../../../helpers";
import {
  responseErros,
  formatPrice,
  unformatPrice,
  timeoutBuscaAutocomplete,
  formatPrecisaoFloat,
} from "../../../../utils";
import shortid from "shortid";
import {
  calcularPrecoProduto,
  calculoDesconto,
  recalcularCascataDeValores,
} from "../add-ordem-servico";
import TabelaCustoDialog from "../../../../components/tabela-custo-dialog/tabela-custo-dialog.component";

const unidadeComercialService = new UnidadeComercialService();
const produtosService = new ProdutosService();
const origemMercadoriaService = new OrigemMercadoriaService();

const OrdemServicoListaProdutos = ({
  id,
  ordemServico,
  setOrdemServico,
  produtoList,
  setProdutoList,
  produto,
  setProduto,
  setLoading,
  listaOrdemServicoProdutos,
  setListaOrdemServicoProdutos,
  removerProdutoCadastrado,
  buscarProdutosSimilares,
  ordemServicoEntity,
  produtosSimilares = [],
  setProdutosSimilares,
  tabelas,
  meioPagamentoSelecionado,
  acrescimoPagamento,
  listaOrdemServicoPagamentos,
  vendedoresList,
  usuariosList,
  permissaoAlterarVendedor,
  permissaoAlterarValorProduto,
  isProdutoEdit,
  setIsProdutoEdit,
  isFechado,
  isCancelado,
  enderecosEstoqueList,
}) => {
  const inputRef = useRef();
  const listaOrdemServicoProdutosRef = useRef([]);
  const [loadingAutoCompleteProd, setLoadingAutoCompleteProd] = useState();
  const [inputValueProduto, setInputValueProduto] = useState("");
  const [itensColumnView, setItensColumnView] = useState(false);
  const [origensMercadoriasList, setOrigensMercadoriasList] = useState([]);
  const [listaUnidadesComerciais, setListaUnidadesComerciais] = useState([]);
  const [openProdutoSimilarDialog, setOpenProdutoSimilarDialog] =
    useState(false);
  const [
    openProdutoEstoqueInformacaoDialog,
    setOpenProdutoEstoqueInformacaoDialog,
  ] = useState(false);
  const [openProdutoAplicacoesDialog, setOpenProdutoAplicacoesDialog] =
    useState(false);
  const [produtosTabelaCusto, setProdutosTabelaCusto] = useState([]);
  const [totaisTabelaCusto, setTotaisTabelaCusto] = useState([]);
  const [openTabelaCustoDialog, setOpenTabelaCustoDialog] = useState(false);
  const [openOrdemCompraDialog, setOpenOrdemCompraDialog] = useState(false);

  const permissoesHelper = new PermisoesHelper();
  const tabelaCustoPermissao = permissoesHelper.temPermisao(
    "tabela-custo-visualizar",
  );
  const ordemCompraPermissao = permissoesHelper.temPermisao(
    "ordem-compra-visualizar",
  );

  useEffect(() => {
    listaOrdemServicoProdutosRef.current = listaOrdemServicoProdutos;
  }, [listaOrdemServicoProdutos]);

  const sessionService = new SessionService();
  const { configuracoes } = sessionService.getEmpresa();
  const usuario = sessionService.getUsuario();

  const colunas = useMemo(() => {
    const cols = [
      {
        field: "codigo",
        headerName: "Cod.",
        flex: 100,
      },
      {
        field: "descricao",
        headerName: "Produto",
        flex: 500,
      },
      ...(configuracoes?.exibirReferenciaPecaServico
        ? [
            {
              field: "referenciaPeca",
              headerName: "Ref. Peça",
              flex: 170,
            },
          ]
        : []),
      {
        field: "quantidade",
        headerName: "Qtd.",
        flex: 90,
        headerAlign: "center",
        align: "center",
        valueGetter: (params) =>
          Number.isInteger(parseFloat(params.value))
            ? params.value
            : params.value.toFixed(3).replace(".", ","),
      },
      {
        field: "valorUnitario",
        headerName: "Valor (R$)",
        flex: 200,
        headerAlign: "right",
        align: "right",
        valueGetter: (params) => formatPrice(parseFloat(params.value)),
      },
      {
        field: "subtotal",
        headerName: "Subtotal (R$)",
        flex: 180,
        headerAlign: "right",
        align: "right",
        valueGetter: (params) =>
          formatPrice(
            parseFloat(params.row.quantidade) *
              parseFloat(params.row.valorUnitario),
          ),
      },
      {
        field: "desconto",
        headerName: "Desconto (R$)",
        flex: 180,
        headerAlign: "right",
        align: "right",
        valueGetter: (params) => formatPrice(parseFloat(params.value)),
      },
      {
        field: "totalItem",
        headerName: "Total (R$)",
        flex: 180,
        headerAlign: "right",
        align: "right",
        valueGetter: (params) => {
          return formatPrice(parseFloat(params.value));
        },
      },
      {
        headerName: "Vendedor",
        flex: 120,
        headerAlign: "center",
        align: "center",
        sortable: false,
        disableClickEventBubbling: true,
        renderCell: (params) => (
          <Avatar
            id={
              params.row.vendedorId
                ? params.row.vendedorId
                : params.row.insertUserId || params.row.updatedUserId
            }
            userList={params.row.vendedorId ? vendedoresList : usuariosList}
          />
        ),
      },
    ];

    if (!(isFechado || isCancelado)) {
      cols.push({
        field: "acoes",
        headerName: "Ações",
        sortable: false,
        flex: 100,
        align: "center",
        headerAlign: "center",
        disableClickEventBubbling: true,
        renderCell: (params) => {
          return (
            <div>
              {!params.row.origemKitId && (
                <IconButton
                  onClick={() => {
                    onClickEditOrdemServicosItens(params.id);
                  }}
                >
                  <Tooltip title="Editar" arrow placement="right">
                    <i
                      className="ph-fill ph-pencil"
                      style={{ fontSize: 18 }}
                    ></i>
                  </Tooltip>
                </IconButton>
              )}
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  onClickDeleteOrdemServicosItens(params.id);
                }}
              >
                <Tooltip title="Excluir" arrow placement="right">
                  <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            </div>
          );
        },
      });
    }

    return cols;
  }, [id, ordemServico?.status]);

  const produtosColunasSimilares = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 280,
    },
    {
      field: "descricao",
      headerName: "Produtos",
      flex: 700,
    },
    {
      field: "estoqueAtual",
      headerName: "Estoque",
      flex: 350,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      flex: 500,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "acoes",
      sortable: false,
      disableClickEventBubbling: true,
      renderHeader: () => {
        return (
          <i
            className="ph-fill ph-note-pencil"
            style={{ fontSize: 20, marginLeft: 14 }}
          ></i>
        );
      },
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              if (params.row) {
                setOpenProdutoSimilarDialog(false);
                setProdutosSimilares([]);
                handleChangeAutocompleteProduto(params.row, false, true);
              }
            }}
            sx={{
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <i
              className="ph-fill ph-paper-plane-right"
              style={{ fontSize: 20, marginLeft: 14 }}
            ></i>
          </IconButton>
        );
      },
    },
  ];

  const buscarProdutos = (
    filtros,
    isProdutoSimilar = false,
    isCodigoBarras = false,
  ) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      limite: 20,
    };
    produtosService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setLoadingAutoCompleteProd(false);
        if (isProdutoSimilar && result.data.rows?.length) {
          const itens = result.data.rows.map((item) => {
            const { informacao, ...rest } = item;
            const produtoResultante = { ...rest, ...informacao, id: rest.id };
            const unidadeProduto = listaUnidadesComerciais.find(
              (unidade) =>
                unidade.id == produtoResultante.unidadeComercialVendaId,
            );
            return montarItem({ ...produtoResultante, unidadeProduto }, false);
          });
          setProdutosSimilares(itens);
          setLoading(false);
          return;
        }

        if (isCodigoBarras) {
          handleChangeAutocompleteProduto(result.data.rows[0], true);
        } else if (result.data.rows.length === 1) {
          handleChangeAutocompleteProduto(result.data.rows[0]);
        } else {
          setProdutoList(result.data.rows);
          setInputValueProduto("");
        }
      } else {
        setLoadingAutoCompleteProd(false);
        setLoading(false);
        responseErros(result);
      }
    });
  };

  const buscarProdutoKit = async (produtoId) => {
    if (produtoId) {
      const result = await produtosService.getById(produtoId);
      if (!result.isAxiosError) {
        return result.data;
      } else {
        responseErros(result);
      }
    }
  };

  const buscarProdutosByCodigo = async (codigoBarra, valorProduto) => {
    const result = await produtosService.getAllProdutosByCodigo({
      codigoBarra,
    });
    if (!result.isAxiosError) {
      setLoadingAutoCompleteProd(false);
      if (result.data.length === 0) return;
      let produto = result.data[0];
      let quantidade = null;
      if (valorProduto) {
        quantidade =
          Math.round((valorProduto / produto.informacao.precoVenda) * 1000) /
          1000;
      }
      produto = {
        ...produto,
        quantidade,
        totalItem: valorProduto,
      };
      handleChangeAutocompleteProduto(produto, true, !!valorProduto);
      setLoading(false);
    } else {
      setLoadingAutoCompleteProd(false);
      responseErros(result);
    }
  };

  const onInputChangeProdutos = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setProdutoList([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = {
        codigo: eventValue,
        descricao: eventValue,
        codigoBarra: eventValue,
        referenciaPeca: eventValue,
      };
      const validacaoCodigoNumerico = /^\d+$/.test(eventValue);
      const isCodigoBalanca =
        configuracoes.inicialCodigoBarrasBalanca ===
          parseFloat(eventValue[0]) && eventValue.length >= 7;
      setLoadingAutoCompleteProd(true);
      if (
        validacaoCodigoNumerico &&
        (configuracoes.buscaProdutosCodigoBarras || isCodigoBalanca)
      ) {
        const codigo = isCodigoBalanca ? eventValue.slice(0, 7) : eventValue;
        let valorProduto = null;
        if (isCodigoBalanca && eventValue.length >= 12) {
          valorProduto =
            parseInt(eventValue.slice(7, 12).replace(/^0+/, "")) / 100;
        }
        timeoutBuscaAutocomplete(buscarProdutosByCodigo(codigo, valorProduto));
      } else {
        const isCodigoBarras =
          validacaoCodigoNumerico && eventValue.length >= 8;
        timeoutBuscaAutocomplete(
          buscarProdutos(filtros, false, isCodigoBarras),
        );
      }
    }
  };

  const buscarUnidadesComerciais = () => {
    if (listaUnidadesComerciais?.length) return;
    unidadeComercialService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setListaUnidadesComerciais(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarOrigensMercadoria = () => {
    origemMercadoriaService.getAll().then((res) => {
      if (!res.isAxiosError) {
        setOrigensMercadoriasList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const onClickDeleteOrdemServicosItens = async (idProduto) => {
    const listaAtual = listaOrdemServicoProdutosRef.current;
    const produto = listaAtual.find((p) => p.id == idProduto);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${
        produto?.descricao ? `"${produto.descricao}"` : "esse item"
      } da lista?`,
    );
    if (!retornoAlerta.isConfirmed) return;
    const referenciaKitId = produto?.origemKitId || produto?.referenciaKitId;

    const listaAtualizada = referenciaKitId
      ? listaAtual.filter(
          (item) =>
            item.origemKitId !== referenciaKitId &&
            item.referenciaKitId !== referenciaKitId,
        )
      : listaAtual.filter((item) => item.id !== idProduto);

    setListaOrdemServicoProdutos(listaAtualizada);
    ordemServicoEntity.setChangeItens(listaAtualizada);
    setOrdemServico({ ...ordemServicoEntity });
    if (id && typeof idProduto === "number") {
      const body = referenciaKitId
        ? { referenciaKitId }
        : { itemId: idProduto };
      removerProdutoCadastrado(body);
    }
  };

  const handleChangeAutocompleteProduto = (
    produtoEscolhido,
    isBuscaCodBar = false,
    isLeituraBalanca = false,
  ) => {
    document.getElementById("produtoId").blur();
    if (produtoEscolhido) {
      const { informacao, ...rest } = produtoEscolhido;
      let produtoResultante = { ...rest, ...informacao, id: rest.id };
      if (produtoEscolhido.tipo === "kit") {
        produtoResultante = {
          ...produtoResultante,
          desconto: null,
          descontoPorcentagem: null,
          frete: null,
          despesas: null,
        };
      }
      const unidadeProduto = listaUnidadesComerciais.find(
        (unidade) => unidade.id == produtoResultante.unidadeComercialVendaId,
      );
      const itemTemp = montarItem(
        {
          ...produtoResultante,
          unidadeProduto,
          vendedorId: null,
        },
        true,
        isLeituraBalanca,
      );
      setProduto(itemTemp);
      if (produtoResultante.similares?.length && !isBuscaCodBar) {
        const listaIdsProdutosSimilares = produtoResultante.similares.map(
          ({ similarId }) => similarId,
        );
        setLoading(true);
        buscarProdutos({ id: listaIdsProdutosSimilares }, true);
      }
      if (!isBuscaCodBar) {
        setTimeout(() => {
          const botaoAdicionar = document.getElementById(
            "buttonAdicionarProduto",
          );
          if (botaoAdicionar) {
            botaoAdicionar.focus();
          }
        }, 100);
      } else {
        handleAdicionarProduto(itemTemp);
      }
    } else {
      setProdutosSimilares([]);
      setProduto(null);
    }
  };

  const montarItem = (
    produtoResultante,
    insertItem = true,
    isLeituraBalanca = false,
  ) => {
    const valorUnitario =
      acrescimoPagamento && !isLeituraBalanca
        ? produtoResultante.precoVenda +
          formatPrecisaoFloat(
            produtoResultante.precoVenda * (acrescimoPagamento / 100),
          )
        : produtoResultante.precoVenda;
    const quantidade = produtoResultante.quantidade ?? 1;
    const totalItem = produtoResultante.totalItem ?? valorUnitario * quantidade;
    let itemTemp = {
      ...produtoResultante,
      quantidade,
      unidade: produtoResultante.unidadeProduto
        ? produtoResultante.unidadeProduto?.codigo
        : "",
      estoqueAtual: produtoResultante?.estoqueProduto?.estoque
        ? `${produtoResultante.estoqueProduto.estoque}`
        : 0,
      produtoId: produtoResultante?.produtoId || produtoResultante.id,
      descricao: produtoResultante?.descricao || "",
      codigo: produtoResultante?.codigo,
      tributosIcmsOrigem: origensMercadoriasList.find(
        (item) => item.id == produtoResultante.origemMercadoriaId,
      )?.codigo,
      ncm: produtoResultante?.ncmCodigo,
      valorUnitario,
      totalItem,
    };
    if (insertItem) {
      itemTemp = { ...produto, ...itemTemp };
    }
    let resultItem = { ...itemTemp };
    if (tabelas?.cliente) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelas?.cliente,
        ordemServico?.meioPagamentoId,
        "cliente",
      );
    } else if (tabelas?.grupoPessoa) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelas?.grupoPessoa,
        ordemServico?.meioPagamentoId,
        "grupoPessoa",
      );
    } else if (produtoResultante?.tabelasVenda?.[0]?.tabelaVenda) {
      resultItem = calcularPrecoProduto(
        resultItem,
        produtoResultante?.tabelasVenda?.[0]?.tabelaVenda || {},
        ordemServico?.meioPagamentoId,
        "meioPagamento",
      );
    } else if (tabelas?.todosProdutos) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelas?.todosProdutos,
        ordemServico?.meioPagamentoId,
        "todos",
      );
    }
    return resultItem;
  };

  useEffect(() => {
    if (listaOrdemServicoProdutos.length > 0 && produto) {
      const produtosAtualizados = listaOrdemServicoProdutos.map(
        (ordemServicoProduto) => {
          let resultItem = {
            ...produto,
            ...ordemServicoProduto,
            quantidade: ordemServicoProduto?.quantidade,
            produtoId: produto?.id,
          };
          if (tabelas?.cliente) {
            resultItem = calcularPrecoProduto(
              resultItem,
              tabelas?.cliente,
              meioPagamentoSelecionado?.id,
              "cliente",
            );
          } else if (tabelas?.grupoPessoa) {
            resultItem = calcularPrecoProduto(
              resultItem,
              tabelas?.grupoPessoa,
              meioPagamentoSelecionado?.id,
              "grupoPessoa",
            );
          } else if (resultItem?.tabelasVenda?.[0]?.tabelaVenda) {
            resultItem = calcularPrecoProduto(
              resultItem,
              resultItem?.tabelasVenda?.[0]?.tabelaVenda || {},
              meioPagamentoSelecionado?.id,
              "meioPagamento",
            );
          } else if (tabelas?.todosProdutos) {
            resultItem = calcularPrecoProduto(
              resultItem,
              tabelas?.todosProdutos,
              meioPagamentoSelecionado?.id,
              "todos",
            );
          }
          return resultItem;
        },
      );
      ordemServicoEntity.setChangeItens(produtosAtualizados);
      setOrdemServico(ordemServicoEntity);
      setListaOrdemServicoProdutos(produtosAtualizados);
    }
  }, [tabelas, meioPagamentoSelecionado]);

  const handleInputChange = (event) => {
    const produtoTemp = {
      ...produto,
      [event.target.name]: event.target.value || null,
    };
    setProduto(produtoTemp);
  };

  const handleInputBlur = (event) => {
    const { name, value } = event.target;
    const valorInserido = parseFloat(unformatPrice(value));

    let produtoAtualizado = recalcularCascataDeValores(
      produto,
      name,
      valorInserido,
    );

    if (
      acrescimoPagamento &&
      name === "valorUnitario" &&
      parseFloat(valorInserido) !== produto.valorUnitario
    ) {
      const valorComAcrescimo =
        valorInserido + (valorInserido * acrescimoPagamento) / 100;
      produtoAtualizado.valorUnitario = formatPrecisaoFloat(valorComAcrescimo);

      produtoAtualizado = recalcularCascataDeValores(
        produtoAtualizado,
        "valorUnitario",
        produtoAtualizado.valorUnitario,
      );
    }

    setProduto((prevState) => ({ ...prevState, ...produtoAtualizado }));
  };

  function onBlurQtd(e) {
    let valorQtd = parseFloat(e.target.value);
    const embalagem = produto?.embalagem * 100;

    if (embalagem && (valorQtd * 100) % embalagem) {
      valorQtd = (Math.ceil((valorQtd * 100) / embalagem) * embalagem) / 100;
      e.target.value = valorQtd;
      handleInputChange(e);
    }

    const itemAtualizado = recalcularCascataDeValores(
      produto,
      "quantidade",
      valorQtd,
    );
    setProduto((prevState) => ({ ...prevState, ...itemAtualizado }));
  }

  const handleAddActionsOpen = () => {
    if (!produto) {
      return notification.alertaGenericos("Selecione um produto");
    }
    setItensColumnView(!itensColumnView);
  };

  const onClickEditOrdemServicosItens = async (itemId) => {
    if (listaOrdemServicoPagamentos?.length > 0) {
      return notification.alertaGenericos(
        "Não é possível editar um produto que já possui pagamentos cadastrados. Remova os pagamentos para editar o produto.",
      );
    }
    const item = listaOrdemServicoProdutosRef.current.find(
      (item) => item.id === itemId,
    );
    if (!item) return;
    if (item.status === "FECHADO") {
      return notification.alertaGenericos(
        "Ítem já importado não pode ser editado",
      );
    }
    setIsProdutoEdit(true);
    setProduto(item);
  };

  const renderValueAutocompleteVendedor = () => {
    if (produto?.vendedorId) {
      return value.autoComplete(vendedoresList, produto?.vendedorId);
    } else {
      const userId = produto?.updatedUserId || produto?.insertUserId;
      const usuario = value.autoComplete(usuariosList, userId);
      return {
        id: usuario.id,
        nomeRazaoSocial: usuario.nome,
      };
    }
  };

  const validarAddProduto = (produto) => {
    if (!produto) {
      notification.alertaGenericos("Selecione um produto para adicionar");
      return true;
    }
    if (!produto.quantidade) {
      notification.erroValidacao("Quantidade do produto");
      return true;
    }
    if (!produto.unidade) {
      notification.erroValidacao("Unidade do produto");
      return true;
    }
    if (configuracoes?.vendedorPorItemServico && !produto.vendedorId) {
      notification.erroValidacao("Vendedor do produto");
      return true;
    }
  };

  const handleAdicionarProduto = async (produto) => {
    if (validarAddProduto(produto)) return;
    let listaItens = [],
      produtoKit = null;
    if (produto.tipo === "kit") {
      produtoKit = await buscarProdutoKit(produto.produtoId);
    }
    if (isProdutoEdit) {
      const produtoIndex = listaOrdemServicoProdutos.findIndex(
        (item) => item.id === produto.id,
      );
      if (produtoIndex >= 0) {
        const produtosKit = listaOrdemServicoProdutos[
          produtoIndex
        ].produtosKit?.map((kitItem) => {
          const quantidadeKit =
            listaOrdemServicoProdutos[produtoIndex].quantidade;
          const proporcao = parseInt(kitItem.quantidade / quantidadeKit);
          return {
            ...kitItem,
            quantidade: (produto.quantidade ?? 1) * proporcao,
          };
        });
        listaItens = listaOrdemServicoProdutos.map((item, _index) =>
          _index === produtoIndex
            ? {
                ...item,
                ...produto,
                produtosKit,
              }
            : item,
        );
      }
    } else {
      if (produtoKit && produto.envioKitItensFiscal) {
        const origemKitId = shortid.generate();
        const kitItens = produtoKit.kits.map((item, index) => {
          const itemProduto = item.produto;
          const quantidade = produto.quantidade * item.quantidade;
          const unidadeProduto = listaUnidadesComerciais.find(
            (unidade) => unidade.id == itemProduto.unidadeComercialVendaId,
          );
          const produtosKit =
            index === 0
              ? [
                  {
                    produtoId: produto.id,
                    quantidade: produto.quantidade,
                  },
                ]
              : null;
          return {
            ...itemProduto,
            quantidade,
            valorUnitario: itemProduto.informacao.precoVenda,
            totalItem: quantidade * itemProduto.informacao.precoVenda,
            origemKitId,
            produtoId: itemProduto.id,
            ncm: itemProduto.informacao.ncmCodigo,
            unidade: unidadeProduto ? unidadeProduto?.codigo : "",
            tributosIcmsOrigem: origensMercadoriasList.find(
              (item) => item.id == itemProduto.origemMercadoriaId,
            )?.codigo,
            id: shortid.generate(),
            produtosKit,
          };
        });
        listaItens = [...listaOrdemServicoProdutos, ...kitItens];
      } else {
        let itensKit = null,
          referenciaKitId = null;
        if (produtoKit) {
          referenciaKitId = shortid.generate();
          itensKit = produtoKit.kits.map((itemKit) => ({
            produtoId: itemKit.produto.id,
            quantidade: produto.quantidade * itemKit.quantidade,
          }));
        }
        listaItens = [
          ...listaOrdemServicoProdutos,
          {
            ...produto,
            id: shortid.generate(),
            produtosKit: itensKit,
            referenciaKitId,
          },
        ];
      }
    }
    setListaOrdemServicoProdutos(listaItens);
    ordemServicoEntity.setChangeItens(listaItens);
    setOrdemServico(ordemServicoEntity);
    document.getElementById("produtoId").focus();
    setIsProdutoEdit(false);
    setProduto(null);
    setProdutoList([]);
    setProdutosSimilares([]);
  };

  useEffect(() => {
    buscarUnidadesComerciais();
    buscarOrigensMercadoria();
  }, []);

  const openProdutoSimilar = () => {
    if (!produto) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar",
      );
    } else {
      setOpenProdutoSimilarDialog(true);
    }
  };

  const openEstoqueDialog = (produtoEscolhido = produto) => {
    if (produtoEscolhido === null) {
      notification.alertaGenericos("Selecione um produto primeiro");
    } else {
      setOpenProdutoEstoqueInformacaoDialog(true);
    }
  };

  const openAplicacoesDialog = () => {
    if (!produto) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar",
      );
    } else {
      setOpenProdutoAplicacoesDialog(true);
    }
  };

  const handleInputDesconto = (event) => {
    if (!produto) return;
    const valor = unformatPrice(event.target.value);

    const itemTemp = {
      ...produto,
      [event.target.name]: valor || 0,
    };

    const subtotal = (itemTemp.valorUnitario || 0) * (itemTemp.quantidade || 1);

    if (event.target.name === "desconto") {
      if (parseFloat(itemTemp.desconto) > subtotal) {
        itemTemp.desconto = subtotal;
      }
      itemTemp.descontoPorcentagem = calculoDesconto(
        [produto],
        itemTemp,
        "desconto",
        "descontoPorcentagem",
        false,
      );
    } else {
      itemTemp.desconto = calculoDesconto(
        [produto],
        itemTemp,
        "desconto",
        "descontoPorcentagem",
      );
    }

    const despesas = parseFloat(itemTemp.despesas || 0);
    const frete = parseFloat(itemTemp.frete || 0);
    itemTemp.totalItem =
      subtotal - parseFloat(itemTemp.desconto || 0) + despesas + frete;

    setProduto(itemTemp);
  };

  const handleOpenTabelaCustoDialog = () => {
    const produtosTabelaCusto = listaOrdemServicoProdutos.map((item) => {
      const quantidade = item.quantidade || 0;
      const precoCusto = item.precoCusto || 1;
      const precoVenda = item.totalItem || 1;
      const totalCustoItem = precoCusto * quantidade;
      const diferenca = ((precoVenda - totalCustoItem) / totalCustoItem) * 100;
      return {
        ...item,
        total: formatPrice(totalCustoItem, false),
        dif: formatPrice(diferenca, false),
      };
    });
    let totaisTabelaCusto = { totalCusto: 0, totalVenda: 0 };
    listaOrdemServicoProdutos.forEach((item) => {
      const totalCusto =
        totaisTabelaCusto.totalCusto +
        (item.precoCusto || 0) * (item.quantidade || 0);
      const totalVenda = totaisTabelaCusto.totalVenda + item.totalItem || 0;
      totaisTabelaCusto.totalCusto = Math.round(totalCusto * 100) / 100;
      totaisTabelaCusto.totalVenda = Math.round(totalVenda * 100) / 100;
    });

    const totalDif =
      totaisTabelaCusto.totalVenda - totaisTabelaCusto.totalCusto;
    totaisTabelaCusto = {
      ...totaisTabelaCusto,
      totalDif: formatPrice(totalDif, false),
      percentualDif: formatPrice(
        (totalDif / totaisTabelaCusto.totalCusto) * 100,
        false,
      ),
    };

    setProdutosTabelaCusto(produtosTabelaCusto);
    setTotaisTabelaCusto(totaisTabelaCusto);
    setOpenTabelaCustoDialog(true);
  };

  const renderSizeItemAutocomplete = () => {
    if (produtosSimilares?.length || produto?.aplicacoes?.length) {
      if (produtosSimilares?.length && produto?.aplicacoes?.length) {
        return 3.5;
      } else {
        return 4;
      }
    } else {
      return 4.5;
    }
  };

  const validacaoEditarVendedor = () => {
    if (id) {
      return (
        produto &&
        (!isProdutoEdit || permissaoAlterarVendedor) &&
        configuracoes?.vendedorPorItemServico
      );
    } else {
      return produto && configuracoes?.vendedorPorItemServico;
    }
  };

  const renderTooltipEnderecoEstoque = () => {
    const enderecoEstoque = enderecosEstoqueList.find(
      ({ id }) => produto.enderecoEstoqueId === id,
    );
    return (
      <Typography
        sx={{
          textAlign: "justify",
          lineHeight: 1.2,
          fontSize: "0.85rem",
          color: "white",
          p: 1,
        }}
      >
        Endereço de Estoque: <b>{enderecoEstoque.endereco}</b>
      </Typography>
    );
  };

  return (
    <>
      <Grid container className="position-relative">
        <Grid
          container
          spacing={2}
          className="mb-2"
          alignItems="center"
          justifyContent="space-between"
          columns={15}
        >
          <Grid item xs={15} md={renderSizeItemAutocomplete()}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                ListboxComponent={ListBoxAutocomplete}
                id="produtoId"
                name="produtoId"
                options={produtoList}
                autoHighlight
                loading={loadingAutoCompleteProd}
                loadingText="Carregando"
                noOptionsText="Digite e clique no ícone para buscar"
                renderOption={(props, option) => {
                  let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                  return option ? (
                    <li {...props} style={{ background: "transparent" }}>
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div>
                          <span className="fw-bold">{descricaoProduto}</span>
                          <div className="d-flex gap-3">
                            <Typography variant="body2">
                              Unidade:{" "}
                              {
                                value.autoComplete(
                                  listaUnidadesComerciais || [],
                                  option?.unidadeComercialVendaId,
                                ).codigo
                              }
                            </Typography>
                            <Typography variant="body2">
                              Cód.barra: {option?.codigoBarra}
                            </Typography>
                          </div>
                          <Typography variant="body2" className="fw-bolder">
                            Estoque disponível:{" "}
                            <span
                              className={
                                option?.estoqueProduto?.estoque < 0
                                  ? "text-danger"
                                  : "text-success"
                              }
                            >
                              {option?.estoqueProduto?.estoque}
                            </span>
                          </Typography>
                        </div>
                        <div className="text-end">
                          <Typography variant="body2">Preço venda</Typography>
                          <span className="fs-6">
                            {formatPrice(option?.informacao?.precoVenda || 0)}
                          </span>
                        </div>
                      </div>
                    </li>
                  ) : (
                    ""
                  );
                }}
                getOptionLabel={(option) => {
                  let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                  return option ? descricaoProduto : "";
                }}
                filterSelectedOptions
                inputValue={inputValueProduto}
                onInputChange={(_, newInputValue) =>
                  setInputValueProduto(newInputValue)
                }
                onChange={(_, value) => handleChangeAutocompleteProduto(value)}
                value={produto ?? ""}
                disabled={id && (isFechado || isCancelado)}
                renderInput={(params) => {
                  const { endAdornment } = params.InputProps;
                  const customIcon = produto?.enderecoEstoqueId && (
                    <Tooltip title={renderTooltipEnderecoEstoque()}>
                      <IconButton size="small">
                        <i
                          className="ph-fill ph-map-pin-area"
                          style={{ fontSize: 20 }}
                        ></i>
                      </IconButton>
                    </Tooltip>
                  );

                  const newEndAdornment = (
                    <>
                      {endAdornment.props.children.slice(0, -1)}
                      {customIcon}
                      {endAdornment.props.children.slice(-1)}
                    </>
                  );
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Buscar produto"
                      required
                      onKeyDown={(e) => onInputChangeProdutos(e)}
                      inputRef={inputRef}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: newEndAdornment,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          paddingRight: "12px !important",
                        },
                      }}
                    />
                  );
                }}
              />
            </FormControl>
          </Grid>
          {produto && (
            <Grid item xs={0.5} sx={{ ps: "8px", mt: "0.5em" }}>
              <Tooltip title="Estoque e Informação do Item" placement="bottom">
                <Button
                  id="buttonEstoqueInformacaoItem"
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{
                    height: "35px",
                    borderRadius: "20%",
                    minWidth: "15px",
                    boxShadow: "none",
                  }}
                  onClick={() => openEstoqueDialog()}
                >
                  <i
                    className="ph-fill ph-package"
                    style={{ color: "#fff", fontSize: 15 }}
                  ></i>
                </Button>
              </Tooltip>
            </Grid>
          )}
          {produto?.aplicacoes?.length ? (
            <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
              <Tooltip title="Aplicações do item" placement="bottom">
                <Button
                  id="buttonAplicacoesItem"
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{
                    height: "35px",
                    borderRadius: "20%",
                    minWidth: "15px",
                    boxShadow: "none",
                  }}
                  onClick={() => openAplicacoesDialog()}
                >
                  <i
                    className="ph-fill ph-circles-three"
                    style={{ color: "#fff", fontSize: 15 }}
                  ></i>
                </Button>
              </Tooltip>
            </Grid>
          ) : null}
          {produtosSimilares?.length ? (
            <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
              <Tooltip title="Consultar Similares" placement="bottom">
                <Button
                  id="buttonSimilarItem"
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{
                    height: "35px",
                    borderRadius: "20%",
                    minWidth: "15px",
                    boxShadow: "none",
                  }}
                  onClick={openProdutoSimilar}
                >
                  <i
                    className="ph-bold ph-approximate-equals"
                    style={{ color: "#fff", fontSize: 15 }}
                  ></i>
                </Button>
              </Tooltip>
            </Grid>
          ) : null}
          <Grid item xs={1}>
            <TextField
              id="estoque"
              name="estoque"
              label="Estoque"
              margin="normal"
              variant={"outlined"}
              disabled
              value={value.text(produto?.estoqueAtual)}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={1}>
            <TextField
              id="quantidade"
              name="quantidade"
              label="Qtd."
              variant={!produto ? "filled" : "outlined"}
              disabled={!produto}
              InputProps={
                produto?.fracionavel
                  ? { inputProps: { min: 0.01, step: 0.01 } }
                  : { inputProps: { min: 1, step: 1 } }
              }
              value={value.text(produto?.quantidade)}
              onChange={(e) => {
                if (e.target.value <= 0) e.target.value = "";
                if (produto?.fracionavel) {
                  e.target.value = Number(e.target.value);
                } else {
                  e.target.value = Math.trunc(Number(e.target.value));
                }
                handleInputChange(e);
              }}
              onBlur={onBlurQtd}
              margin="normal"
              type="number"
              required
            />
          </Grid>
          <Grid item xs={2}>
            {acrescimoPagamento > 0 ? (
              <Tooltip
                title={`Esse valor tem acréscimo de ${acrescimoPagamento}% pela condição de pagamento escolhida`}
                placement="top"
              >
                <CurrencyInput
                  id="valorUnitario"
                  name="valorUnitario"
                  label="Valor Unitário R$"
                  variant={!produto ? "filled" : "outlined"}
                  disabled={
                    !produto ||
                    produto?.tipo === "kit" ||
                    !permissaoAlterarValorProduto
                  }
                  value={value.text(produto?.valorUnitario)}
                  onBlur={handleInputBlur}
                />
              </Tooltip>
            ) : (
              <CurrencyInput
                id="valorUnitario"
                name="valorUnitario"
                label="Valor Unitário R$"
                variant={!produto ? "filled" : "outlined"}
                disabled={
                  !produto ||
                  produto?.tipo === "kit" ||
                  !permissaoAlterarValorProduto
                }
                value={value.text(produto?.valorUnitario)}
                onBlur={handleInputBlur}
              />
            )}
          </Grid>
          <Grid item xs={2}>
            <CurrencyInput
              id="totalItem"
              name="totalItem"
              label="Total Item R$"
              variant={!produto ? "filled" : "outlined"}
              disabled={!produto || produto?.tipo === "kit"}
              value={value.text(produto?.totalItem)}
              onBlur={handleInputBlur}
            />
          </Grid>
          <Grid item xs={3}>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="vendedorId"
                name="vendedorId"
                getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
                options={vendedoresList}
                autoHighlight
                disabled={!validacaoEditarVendedor()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Vendedor"
                    variant={validacaoEditarVendedor() ? "outlined" : "filled"}
                    disabled={!validacaoEditarVendedor()}
                    margin="normal"
                    required
                  />
                )}
                onChange={(e, newValue) => {
                  e.persist();
                  setProduto((prevState) => ({
                    ...prevState,
                    vendedorId: newValue?.id,
                  }));

                  setTimeout(() => {
                    const botaoAdicionar = document.getElementById(
                      "buttonAdicionarProduto",
                    );
                    if (botaoAdicionar) botaoAdicionar.focus();
                  }, 100);
                }}
                value={renderValueAutocompleteVendedor()}
              />
            </FormControl>
          </Grid>
          <Grid item xs={0.5}>
            <IconButton
              variant="contained"
              size="small"
              onClick={handleAddActionsOpen}
            >
              <i
                className="ph-bold ph-caret-down"
                style={{
                  color: "#494c62",
                  rotate: itensColumnView ? "180deg" : "0deg",
                }}
              ></i>
            </IconButton>
          </Grid>
          <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
            <Tooltip
              title={isProdutoEdit ? "Atualizar Produto" : "Adicionar Produto"}
            >
              <Button
                id="buttonAdicionarProduto"
                variant="contained"
                color={isProdutoEdit ? "primary" : "success"}
                disabled={!produto || (id && (isFechado || isCancelado))}
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "50%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => handleAdicionarProduto(produto)}
              >
                <i
                  className={
                    isProdutoEdit
                      ? "ph-bold ph-arrows-clockwise"
                      : "ph-bold ph-plus"
                  }
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        {itensColumnView && (
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextFielDecimalNumbers
                    id="descontoPorcentagem"
                    name="descontoPorcentagem"
                    label="Desconto (%)"
                    variant="outlined"
                    disabled={produto?.tipo === "kit"}
                    value={produto?.descontoPorcentagem ?? 0}
                    onBlur={handleInputDesconto}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CurrencyInput
                    id="desconto"
                    name="desconto"
                    label="Desconto (R$)"
                    variant="outlined"
                    disabled={produto?.tipo === "kit"}
                    value={produto?.desconto ?? 0}
                    onBlur={handleInputDesconto}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2}>
              <CurrencyInput
                id="despesas"
                name="despesas"
                label="Despesas"
                disabled={produto?.tipo === "kit"}
                value={produto?.despesas ? produto.despesas : ""}
                onBlur={handleInputBlur}
              />
            </Grid>
          </Grid>
        )}
        <Grid container spacing={3}>
          <Grid style={{ marginTop: 32 }} item xs={12}>
            <DataGrid
              style={{ zIndex: 1 }}
              rows={listaOrdemServicoProdutos}
              rowCount={listaOrdemServicoProdutos.length}
              columns={colunas}
              disableAcoes
            />
          </Grid>
        </Grid>
        <ProdutoSimilarDialog
          produto={produto}
          openProdutoSimilarDialog={openProdutoSimilarDialog}
          setOpenProdutoSimilarDialog={setOpenProdutoSimilarDialog}
          buscarProdutosSimilares={buscarProdutosSimilares}
          produtosColunasSimilares={produtosColunasSimilares}
          produtosSimilares={produtosSimilares}
        />
        <ProdutoEstoqueInformacaoDialog
          produto={produto}
          open={openProdutoEstoqueInformacaoDialog}
          setOpen={setOpenProdutoEstoqueInformacaoDialog}
          usuario={usuario}
          handleChangeAutocompleteProduto={handleChangeAutocompleteProduto}
        />
        <DocumentoProdutoAplicacaoDialog
          open={openProdutoAplicacoesDialog}
          setOpen={setOpenProdutoAplicacoesDialog}
          aplicacoesProduto={produto?.aplicacoes}
        />
        <TabelaCustoDialog
          openDialog={openTabelaCustoDialog}
          setOpenDialog={setOpenTabelaCustoDialog}
          produtos={produtosTabelaCusto}
          totais={totaisTabelaCusto}
        />
        <OrdemCompraDialog
          openDialog={openOrdemCompraDialog}
          setOpenDialog={setOpenOrdemCompraDialog}
          itens={ordemServicoEntity.itens}
          produtos={listaOrdemServicoProdutos}
          setProdutos={setListaOrdemServicoProdutos}
        />
      </Grid>
    </>
  );
};

export default OrdemServicoListaProdutos;
